import { QUERY_MOBILE_LANDSCAPE } from '../variables'

export const breakpoints = {
  custom: {
    mobileLandscape: QUERY_MOBILE_LANDSCAPE
  }
}

export default breakpoints
